<template>
  <a-modal title="跟进信息" v-model="visible">
    <div v-for="(item, index) in list" :key="item.id">
      <a-row type="flex" justify="space-between">
        <a-col>跟进人：{{item.ie_name}}</a-col>
        <a-col>跟进时间：{{item.created_at}}</a-col>
      </a-row>
      <a-row type="flex" justify="space-between">
        <a-col>跟进类型：<span style="color:#4b9f4d;">{{item.follow_type_name}}</span></a-col>
        <a-col v-if="item.follow_type === '1'" style="margin-right:99px;">跟进类别：{{item.follow_channel_name}}</a-col>
      </a-row>
      <template v-if="item.follow_type === '1'">
        <a-row type="flex" justify="space-between">
          <a-col>跟进渠道：{{item.active_handle_type_name}}</a-col>
          <a-col>激活时间：{{item.created_at}}</a-col>
        </a-row>
        <a-row type="flex" justify="space-between">
          <a-col>激活事件：{{item.pm_renew.handle_event_name}}</a-col>
          <a-col>释放时间：{{item.release_at}}</a-col>
        </a-row>
        <a-row type="flex" justify="space-between">
          <a-col>猎头意愿评分：{{item.star}}星</a-col>
        </a-row>
      </template>
      <a-row type="flex" justify="space-between">
        <a-col>跟进内容：{{item.body}}</a-col>
      </a-row>
      <a-row type="flex" justify="space-between" v-if="item.follow_type === '1'">
        <a-col>附加说明：
          <a :href="info.file_url" :key="i" v-for="(info,i) in item.remark_attachments" :download="info.name">
            <span style="margin-right:10px;color: #2390d9;">{{info.file_name}}</span>
          </a>
        </a-col>
      </a-row>
      <a-divider v-if="(index+1) < list.length"></a-divider>
    </div>
    <template slot="footer">
      <a-button @click="close">取消</a-button>
    </template>
  </a-modal>
</template>

<script>
import baseModalVue from "@/components/base-modal";
import Api from "@/api";
export default {
  name: "MarkDetailModal",
  extends: baseModalVue,
  data() {
    return {
      list: []
    };
  },
  methods: {
    async show(id) {
      let { remarks } = await Api.hunter.getAllRemark({ user_id: id });
      if (remarks.length === 0) {
        this.$message.info("暂无沟通记录");
        return;
      }
      this.list = remarks;
      this.open();
    },
  }
};
</script>

<style lang="scss">
</style>
